<div class="restricted-message-container">
  <ng-container *ngIf="full">
    <u-icon [model]="restrictedIcon" [styles]="{ color: 'var(--color-text-tertiary)' }"></u-icon>
    <span class="text">Restricted access</span>
    <u-icon
      class="message-icon"
      [model]="tooltipIcon"
      [styles]="{ fontSize: '13px' }"
      [escape]="false"
      [pTooltip]="restrictedTooltip"
      tooltipStyleClass="u-tooltip restricted"
      tooltipPosition="left"
      (click)="openLearnMore($event)"
    ></u-icon>
  </ng-container>

  <u-icon
    *ngIf="!full"
    [model]="restrictedIcon"
    [styles]="{ color: 'var(--color-text-tertiary)' }"
    [pTooltip]="restrictedTooltip"
    [escape]="false"
    tooltipStyleClass="u-tooltip restricted"
    tooltipPosition="left"
    (click)="openLearnMore($event)"
  ></u-icon>
</div>
